import React from 'react';
import { useTranslation } from '../../lib/i18n';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { currentLanguage, setLanguage, getAvailableLanguages, t } = useTranslation();

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
  };

  const availableLanguages = getAvailableLanguages();

  return (
    <div className="language-switcher">
      <label htmlFor="language-select" className="language-label">
        {t('common.language')}:
      </label>
      <select
        id="language-select"
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="language-select"
      >
        {availableLanguages.map(lang => (
          <option key={lang} value={lang}>
            {t(`common.${lang === 'en' ? 'english' : 'traditionalChinese'}`)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
